import { html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { TeComponent } from './common/te-component';
import { theme } from './common/theme';
import './te-text';

/**
 * Search Spotlight Group Component
 *
 * @slot - Default slot for spotlight items
 */
@customElement('te-spotlight-group')
export class TeSpotlightGroup extends TeComponent {
  static styles = [
    ...TeComponent.styles,
    css`
      .spotlight-group {
        display: flex;
        flex-direction: column;
        margin: 0;
        padding: 0;
      }

      .group-title {
        background-color: ${theme.colors.shade1};
        display: flex;
        align-items: center;
        padding: 0px 16px;
        height: 32px;
        border-bottom: 1px solid ${theme.colors.shade2};
      }

      .group-title.first-group-title {
        border-radius: 4px 4px 0 0;
      }
    `,
  ];

  /** Title text for group */
  @property({ type: String }) heading = '';

  render() {
    return html`
      <div class="spotlight-group">
        <div class="group-title" @click=${this.handleClick}>
          <te-text size="12">${this.heading || 'Group'}</te-text>
        </div>
        <slot></slot>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-spotlight-group': TeSpotlightGroup;
  }
}
